module.exports = __webpack_public_path__ + "static/media/株洲博物馆美术馆-min.5d55e4c5.jpg";